
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import * as API from '@/modules/admin/events/_api';
import {withFreshBlockIds} from '@/modules/admin/events/_components/templateBlocks';

@Component
export default class DlgEventTemplateCopyFrom extends Vue {
  @Prop({type: Object, default: () => ({})}) public event!: any;

  @Action('admin/events/read') private readEvents!: () => Promise<any>;
  @Action('admin/events/createTemplate') private createTemplate!: (params: any) => Promise<any>;
  @Getter('admin/events/all') private allEvents!: any[];

  public dialog: boolean = false;
  public loading: boolean = false;
  public sourceEventId: string = '';
  public sourceTemplates: any[] = [];
  public sourceTemplatesLoading: boolean = false;
  private sourceEventFetchId: number = 0;
  public sourceTemplatesError: boolean = false;

  get sourceEventOptions() {
    if (!this.allEvents) {
      return [];
    }
    return this.allEvents
      .filter((e: any) => e.id !== this.event.id)
      .slice()
      .sort((a: any, b: any) => {
        const da = a.date ? new Date(a.date).getTime() : 0;
        const db = b.date ? new Date(b.date).getTime() : 0;
        return db - da;
      })
      .map((e: any) => ({
        id: e.id,
        label: e.date
          ? `${e.title} — ${this.formatDate(e.date)}`
          : e.title,
      }));
  }

  private formatDate(value: string): string {
    const d = new Date(value);
    return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
  }

  @Watch('dialog')
  private async onDialogToggle(open: boolean) {
    if (!open) {
      return;
    }
    this.sourceEventId = '';
    this.sourceTemplates = [];
    this.sourceTemplatesError = false;
    if (!this.allEvents || this.allEvents.length === 0) {
      this.loading = true;
      await this.readEvents();
      this.loading = false;
    }
  }

  @Watch('sourceEventId')
  private async onSourceEventChange(id: string) {
    const fetchId = ++this.sourceEventFetchId;
    this.sourceTemplates = [];
    this.sourceTemplatesError = false;
    if (!id) {
      return;
    }
    this.sourceTemplatesLoading = true;
    try {
      const result = await API.readTemplates(id);
      if (fetchId === this.sourceEventFetchId) {
        this.sourceTemplates = result;
      }
    } catch (ex) {
      if (fetchId === this.sourceEventFetchId) {
        this.sourceTemplatesError = true;
        this.$store.dispatch(
          'common/snackbar/error',
          'Vorlagen konnten nicht geladen werden.',
        );
      }
    }
    if (fetchId === this.sourceEventFetchId) {
      this.sourceTemplatesLoading = false;
    }
  }

  public async pickTemplate(t: any) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    const template = {
      title: `Kopie von ${t.title}`,
      subject: t.subject,
      html: t.html,
      template: withFreshBlockIds(t.template),
    };
    const success = await this.createTemplate({id: this.event.id, template});
    this.loading = false;
    if (success) {
      this.$emit('copied');
      this.dialog = false;
    }
  }

  public close() {
    this.dialog = false;
  }
}
